import { jsx as _jsx } from "react/jsx-runtime";
import { UserDetailsPage } from "@/views/users/userDetails/UserDetailsPage";
import { UserEditPage } from "@/views/users/userEdit/UserEditPage";
import UserListPage from "@/views/users/userList";
import { RoutesList } from "../routesList";
/** Роуты для списка пользователей */
export var routesUsers = [
    {
        path: RoutesList.Users.getUsersList(),
        element: _jsx(UserListPage, {}),
    },
    {
        path: RoutesList.Users.getUsersFavorites(),
        element: _jsx(UserListPage, { isFavorites: true }),
    },
    {
        path: RoutesList.Users.getUserDetails(":userId"),
        element: _jsx(UserDetailsPage, {}),
    },
    {
        path: RoutesList.Users.getUserEdit(":userId"),
        element: _jsx(UserEditPage, {}),
    },
];
